import React, {useContext} from "react";

const Context = React.createContext({
    name:'Juan',
    ok: true
})

export default Context